import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './carousel.css';
export default React.memo(({ isMobile }) => {
  const liStyle = 'items-center justify-center flex flex-col text-2xl';
  const imgStyle = 'rounded-xl object-contain ';
  return (
    <Carousel autoPlay infiniteLoop showThumbs={false} width={isMobile ? 300 : 550}>
      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo3.jpeg" />
      </div>
      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo14.jpeg" />
      </div>
      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo2.jpeg" />
      </div>
      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo15.jpeg" />
      </div>
      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo6.jpeg" />
      </div>

      <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo16.jpeg" />
      </div>
      {/*    <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo12.jpeg" />
      </div> */}

      {/*     <div className={liStyle}>
        <img className={imgStyle} alt="" src="./images/photo13.jpeg" />
      </div> */}
    </Carousel>
  );
});
